module.exports = __webpack_public_path__ + "static/img/face.0d58590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face.png
// module id = 0BTH
// module chunks = 10